import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: 0,
    borderRight: `1px solid ${tokens.colorNeutralStroke1}`,
    overflow: 'hidden',
  },
  tabList: {
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    padding: `0 ${tokens.spacingHorizontalS}`,
    minHeight: '36px',
  },
  content: {
    flex: '1',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
});
